import React from 'react';
import fr from 'facet-rest';
import {
  useDashboardContext,
} from 'Views/Dashboard/DashboardContext';
import useMobileLayout from 'Hooks/useMobileLayout';
import CuratedContentDesktop from './CuratedContentDesktop';
import CuratedContentMobile from './CuratedContentMobile';

const CuratedContentSectionPicker = () => {
  const { clientDashboardResource } = useDashboardContext();
  const isMobile = useMobileLayout();

  return clientDashboardResource.withRelationship(fr.relationships.curatedContentArticles.name, (_) => {
    const articles = clientDashboardResource?.attr('curatedContentArticles')?.resources()?.list() || [];

    // Return nothing if there are no articles
    if (articles.length === 0) {
      return null;
    }

    if (isMobile) {
      return (
        <CuratedContentMobile />
      );
    }

    return (
      <CuratedContentDesktop />
    );
  },
  () => null);
};

export default CuratedContentSectionPicker;
